import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import RestaurantRegisterReview from "./RestaurantRegisterReview";

function Review({
  role,
  formData,
  setOwnerAvatar = () => {},
  setReviewDetails = () => {},
}) {
  const { t } = useTranslation();

  const handleOwnerAvatar = useCallback(
    (avatar) => {
      setOwnerAvatar(avatar);
    },
    [setOwnerAvatar]
  );

  return (
    <div
      className={`register-step ${
        role === "restaurant" ? "register-step--review" : ""
      }`}
    >
      <div className="step-header">
        <h2>{t("register.stepReview.title")}</h2>
      </div>
      {role === "company" && (
        <div className="row">
          {Object.entries(formData).map(([key, value]) => {
            if (key === "blank") return null;
            else
              return (
                <div
                  className={`mb-4 px-2 column ${
                    key === "message" ? "w-100" : "w-50"
                  } ${key === "role" && "hidden"}`}
                  key={key}
                >
                  <span className="bold">
                    {t(`register.stepReview.company.${key}`)}
                  </span>
                  <span>{value.value ? value.value.label : value}</span>
                </div>
              );
          })}
        </div>
      )}
      {role === "restaurant" && (
        <RestaurantRegisterReview
          form={formData}
          setOwnerAvatar={handleOwnerAvatar}
          setReviewDetails={setReviewDetails}
        />
      )}
    </div>
  );
}

export default Review;
